import { render, staticRenderFns } from "./InternalNavCurrent.vue?vue&type=template&id=542bf086&"
import script from "./InternalNavCurrent.vue?vue&type=script&lang=js&"
export * from "./InternalNavCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports